import Vuex from 'vuex';
const globalStore = {
  state: () => ({
    userOkrAndWeeklyAuthInfo: {
      allow_daily: false,
      allow_databoard: false,
      allow_entrance: false,
      allow_okr: false,
      allow_weekly: false,
    }
  }),
  mutations: {
    storeSetUserOkrAndWeeklyAuthInfo(state, payload) {
      state.userOkrAndWeeklyAuthInfo = { ...state.userOkrAndWeeklyAuthInfo, ...payload }
    }
  }
}
const createStore = () => {
  const store = new Vuex.Store({
    state: {},
    mutations: {},
    modules: {
      globalStore,
    }
  })
  return store;
}

export default createStore;